import * as request from "@/utils/request";
import { DefaultConfigs } from "@/common/js/constant";
import { PageData, SimCalcData, SimCalcRes } from "./types";

// 拼接页面url上的参数
const baseUrl = `${DefaultConfigs.publicAPIPath}`;

export function getSimulatedEarningsPageData(): Promise<PageData> {
  return request.post<PageData>(`${baseUrl}/sofipo/uchome/v0/simulator/h5`, {});
}

// 计算模拟利息
export function getEarningCalc(params: SimCalcData): Promise<SimCalcRes> {
  return request.post<SimCalcRes>(`${baseUrl}/sofipo/v0/main/earning/calc`, params);
}
